/********************/
/*** AWARD SWIPER ***/
/********************/

// IMPORT SWIPER
import Swiper, { Navigation, Pagination } from 'swiper';
import "swiper/css";

new Swiper('#AwardsSwiper', {
    modules: [Navigation, Pagination],
    slidesPerView: 'auto',
    spaceBetween: 20,
    centerInsufficientSlides: true,
    grabCursor: true,
    pagination: {
        el: '.swiper-pagination'
    },
    navigation: {
        prevEl: '.award-swiper-button-prev',
        nextEl: '.award-swiper-button-next',
        disabledClass: 'award-swiper-button-disabled',
        lockClass: 'award-swiper-button-lock'
    }
})
